import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import { AuthProvider } from "layouts/authentication/AuthContext";

// Get the root container to render the app
const container = document.getElementById("app");
const root = createRoot(container);

// Render the application with context providers and routing

//hello
root.render(
  <BrowserRouter>
    <AuthProvider>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </AuthProvider>
  </BrowserRouter>
);

// Register the service worker if supported by the browser
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        // console.log("ServiceWorker registered with scope:", registration.scope);
      })
      .catch((error) => {
        // console.log("ServiceWorker registration failed:", error);
      });
  });
}
